import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import { URL } from "../../Redux/common/url";
import { Link, useLocation } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";

function Category({ homedata }) {
  const recentCategories = homedata?.categorylist || [];
  const [isLoaded, setIsLoaded] = useState(false);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const pagev = searchParams.get("page");
  const searchData = searchParams.get("search");

  const serr = searchData ? searchData : "silver-jewellery";

  useEffect(() => {
    const cards = document.querySelectorAll(".category-card");

    cards.forEach((card) => {
      const field = document.createElement("div");
      field.className = "particles-field";
      card.appendChild(field);

      for (let i = 0; i < 25; i++) {
        const particle = document.createElement("div");
        particle.className = "particle";
        particle.style.setProperty("--x", `${Math.random() * 200 - 100}px`);
        particle.style.setProperty("--y", `${Math.random() * 200 - 100}px`);
        particle.style.animation = `particleFloat ${1 + Math.random() * 2}s infinite ease-in-out`;
        particle.style.animationDelay = `${Math.random() * 2}s`;
        particle.style.left = `${Math.random() * 100}%`;
        particle.style.top = `${Math.random() * 100}%`;
        field.appendChild(particle);
      }
    });
  }, [recentCategories]);

  return (
    <div className="category-slider-container px-1 mt-4 category-new-a">
      <div className="category-header position-relative overflow-hidden d-flex justify-content-between align-items-center p-2 mb-2">
        <div>
          <h5 className="fw-bold category-text mb-0">CATEGORY</h5>
        </div>
        <div>
          <Link
            className="text-decoration-none fw-bold category-text"
            to={"/sub-category/" + serr}
          >
            View all
          </Link>
        </div>
        <span className="mannu-bhai"></span>
        <span className="mannu-bhai"></span>
        <span className="mannu-bhai"></span>
        <span className="mannu-bhai"></span>
      </div>

      {recentCategories.length > 0 && (
        <Swiper
          modules={[Autoplay]}
          spaceBetween={15}
          autoplay={{ delay: 1800, disableOnInteraction: false }}
          loop={true}
          speed={1000}
          breakpoints={{
            320: { slidesPerView: 2 },
            768: { slidesPerView: 4 },
            1024: { slidesPerView: 8 },
          }}
        >
          {recentCategories.map((data, index) => (
            <SwiperSlide key={data._id}>
              <Link
                to={`/category-products/${data?.slug}`}
                className="text-decoration-none"
              >
                <div className="category-card tilt">
                  <div className="img-box">
                    <img
                      src={URL?.API_BASE_URL + data?.image}
                      alt={`slider${index}`}
                      className={`rounded-circle blur-image ${isLoaded ? "hide" : ""}`}
                      style={{
                        filter: "blur(20px)",
                        transition: "opacity 0.3s ease-in-out",
                        opacity: isLoaded ? 0 : 1,
                      }}
                    />
                    <LazyLoadImage
                      alt={`slider${index}`}
                      className=""
                      delayTime={300}
                      onLoad={() => setIsLoaded(true)}
                      style={{
                        transition: "opacity 0.3s ease-in-out",
                        opacity: isLoaded ? 1 : 0,
                      }}
                      src={URL?.API_BASE_URL + data?.image}
                    />
                  </div>

                  <span className="mannu-bhai"></span>
                  <span className="mannu-bhai"></span>
                  <span className="mannu-bhai"></span>
                  <span className="mannu-bhai"></span>

                  <p>
                    {data?.name?.length > 15
                      ? data?.name.substring(0, 15) + "..."
                      : data?.name}
                  </p>
                </div>
              </Link>
            </SwiperSlide>
          ))}
        </Swiper>
      )}
    </div>
  );
}

export default Category;

// import React, { useState } from "react";
// import Slider from "react-slick";
// import { URL } from "../../Redux/common/url";
// import { Link } from "react-router-dom";
// import { LazyLoadImage } from "react-lazy-load-image-component";

// function Category({ homedata }) {
//   const get_home_all_pro = homedata;

//   const recentrecentProduct = get_home_all_pro?.categorylist
//     ? get_home_all_pro?.categorylist
//     : [];

//   var settings = {
//     dots: false,
//     infinite: true,
//     autoplay: true,
//     autoplaySpeed: 3000,
//     speed: 500,
//     slidesToShow:
//       get_home_all_pro?.categorylist?.length == 1
//         ? 1
//         : get_home_all_pro?.categorylist?.length > 8
//           ? 8
//           : get_home_all_pro?.categorylist?.length - 1,
//     slidesToScroll: 1,
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow:
//             get_home_all_pro?.categorylist?.length == 1
//               ? 1
//               : get_home_all_pro?.categorylist?.length > 4
//                 ? 4
//                 : get_home_all_pro?.categorylist?.length - 1,
//           slidesToScroll: 3,
//           infinite: true,
//           dots: false,
//         },
//       },
//       {
//         breakpoint: 600,
//         settings: {
//           slidesToShow:
//             get_home_all_pro?.categorylist?.length == 1
//               ? 1
//               : get_home_all_pro?.categorylist?.length > 3
//                 ? 3
//                 : get_home_all_pro?.categorylist?.length - 1,
//           slidesToScroll: 2,
//           initialSlide: 2,
//         },
//       },
//       {
//         breakpoint: 480,
//         settings: {
//           slidesToShow:
//             get_home_all_pro?.categorylist?.length == 1
//               ? 1
//               : get_home_all_pro?.categorylist?.length > 3
//                 ? 3
//                 : get_home_all_pro?.categorylist?.length - 1,
//           slidesToScroll: 1,
//         },
//       },
//     ],
//   };
//   const [isLoaded, setIsLoaded] = useState(false);
//   return (
//     <div>
//       <div className="categry lostfound  mb-5">
//         <div className="ps-container ps-deal-of-day">
//           <div className="ps-section__header">
//             <div className="ps-block--countdown-deal">
//               <div className="ps-block__left">
//                 <h3>
//                   <b>CATEGORY</b>{" "}
//                 </h3>
//               </div>
//             </div>
//             <Link to="/category">View all</Link>
//           </div>
//           <div className="ps-section__content catetext">
//             {recentrecentProduct?.length > 0 && (
//               <Slider {...settings}>
//                 {recentrecentProduct &&
//                   recentrecentProduct?.map((data, i) => {
//                     return (
//                       <div className="recentlostfound" key={data._id}>
//                         <div className="ps-product">
//                           <div className="ps-product__thumbnail categorycom">
//                             <Link to={"/category-products/" + data?.slug}>
//                               <img
//                                 src={URL.API_BASE_URL + data?.image}
//                                 className="rounded-circle"
//                                 alt={data?.name}
//                                   loading="lazy"
//                               />
//                                 <img
//                             src={URL?.API_BASE_URL + data?.image}
//                             alt={"slider" + i}
//                             className={`rounded-circle blur-image ${isLoaded ? "hide" : ""}`}
//                             style={{
//                               filter: "blur(20px)",
//                               transition: "opacity 0.3s ease-in-out",
//                               opacity: isLoaded ? 0 : 1,
//                             }}
//                           />
//                           <LazyLoadImage
//                             alt={"slider" + i}
//                             width={imageWidth}
//                             height={imageHeight}
//                             className="rounded-circle"
//                             delayTime={300}
//                             onLoad={() => setIsLoaded(true)}
//                             style={{
//                               transition: "opacity 0.3s ease-in-out",
//                               opacity: isLoaded ? 1 : 0,
//                             }}
//                             src={URL?.API_BASE_URL + data?.image}
//                           />
//                             </Link>
//                           </div>
//                           <div className="ps-product__container">
//                             <div className="ps-product__content">
//                               <Link
//                                 className="ps-product__title"
//                                 to={"/category-products/" + data?.slug}
//                               >
//                                 {data?.name}
//                               </Link>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     );
//                   })}
//               </Slider>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Category;
